import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ApiConfigurationErrorRoot = styled(Box)`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(4, 3)};
  background-color: ${({ theme }) => theme.palette.background.default};
`;

export const ApiConfigurationErrorPanel = styled(Box)`
  max-width: 520px;
  width: 100%;
`;

export const ApiConfigurationErrorTitle = styled(Typography)`
  ${({ theme }) => theme.typography.h5};
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const ApiConfigurationErrorBody = styled(Typography)`
  ${({ theme }) => theme.typography.body1};
  color: ${({ theme }) => theme.palette.text.secondary};
  white-space: pre-wrap;
`;
